import * as Yup from 'yup';

// User Login Schema Validation
export const validationLoginSchema = Yup.object().shape({
    username: Yup.string().required('Nom d\'utilisateur requis'),
    password: Yup.string().required('Mot de passe requis'),
});